import { createContext } from "react";
import { UserToken } from "../../amorg-common";
import React from "react";
import { ThemeProvider } from "styled-components";
import { colors, ColorSystem } from "../../designSystem/colors/color";
import { applyPartnerColors } from "../../designSystem/colors/CustomizableColors";
import { AmorgStyles, amorgStyles } from "../../designSystem/styles/amorgStyles";

type ProtectedPageContextType = {
    user:UserToken | null,
    colors:ColorSystem,
    styles:AmorgStyles
}

export const ProtectedPageContext = createContext<ProtectedPageContextType>({
    user:null, 
    colors, 
    styles:amorgStyles(colors)
});

type ProtectedPageProviderProps = {
    user: UserToken | null,
    children?:React.ReactNode
}
export function ProtectedPageProvider(props:ProtectedPageProviderProps):JSX.Element
{
    React.useMemo(() => {
        applyPartnerColors(props.user?.partner);
    }, [props.user?.partner]);

    const styles = amorgStyles(colors);

    return (
        <ProtectedPageContext.Provider value={{
            user: props.user, 
            colors, 
            styles}}>

            {/* Type of theme is defined in styled.d.ts */}
            <ThemeProvider theme={{colors, styles}}>
                {props.children}
            </ThemeProvider>
        </ ProtectedPageContext.Provider>
    )
}